/* r16tekst f:borduurtekst: type a name instead of uploading a file.
   The text is drawn in a canvas (chosen font, thread colour, transparent background), turned into a PNG File and put into the
   existing upload field (input[data-bp-file]) with a change event, so the existing preview does place, size and calibration.
   Settings (max length, fonts, colours) come from the markup of snippets/tt-borduurtekst.liquid, nothing is typed here. */
(function () {
  'use strict';
  var root = document.querySelector('[data-tt-btx]');
  if (!root || root.dataset.ttBtxInit) return;
  root.dataset.ttBtxInit = '1';
  var bp = document.getElementById(root.dataset.bp);
  if (!bp) return;

  var FILE_NAME = 'borduurtekst.png';
  var MAX = parseInt(root.dataset.max, 10);
  var LICHT = root.dataset.licht.split(',');
  // Characters every offered font has (latin subset): printable ASCII, Latin-1 letters with accents, euro, curly quotes.
  var ALLOWED = /^[ -~À-ÖØ-öø-ÿ€‘’“”]+$/;

  var fileIn = bp.querySelector('[data-bp-file]');
  var uploadPaneel = bp.querySelector('[data-tt-upload-paneel]');
  var paneel = root.querySelector('[data-tt-btx-paneel]');
  var inp = root.querySelector('[data-tt-btx-in]');
  var teller = root.querySelector('[data-tt-btx-teller]');
  var melding = root.querySelector('[data-tt-btx-melding]');
  var knoppen = root.querySelectorAll('[data-tt-btx-modus]');
  var fontBtns = root.querySelectorAll('[data-tt-btx-font]');
  var kleurBtns = root.querySelectorAll('[data-tt-btx-kleur]');
  var out = {};
  root.querySelectorAll('[data-tt-btx-out]').forEach(function (e) { out[e.dataset.ttBtxOut] = e; });
  var errFile = bp.querySelector('[data-bp-err-file] span');
  // The empty-state message is ours: "upload or type".
  if (errFile) errFile.textContent = root.dataset.msgLeeg;

  kleurBtns.forEach(function (b) { b.querySelector('.tt-btx__stip').style.background = 'rgb(' + b.dataset.rgb.split(' ').join(',') + ')'; });
  var state = { modus: 'upload', font: fontBtns[0], kleur: null, kleurGekozen: false, seq: 0, fonts: {} };

  function ours() { return !!(fileIn.files && fileIn.files[0] && fileIn.files[0].name === FILE_NAME); }
  function clearDesign() { if (bp.ttClearDesign) bp.ttClearDesign(); }
  function melden(t) { melding.textContent = t || ''; melding.hidden = !t; }
  function props(on) {
    ['tekst', 'font', 'kleur'].forEach(function (k) { out[k].disabled = !on; if (!on) out[k].value = ''; });
  }
  function setPressed(list, el, attr) {
    list.forEach(function (b) { var on = b === el; b.classList.toggle('is-active', on); b.setAttribute(attr, on ? 'true' : 'false'); });
  }

  // Default thread colour = contrast with the chosen garment colour (light garment: Zwart, dark: Wit).
  function garmentLight() {
    var a = bp.querySelector('[data-bp-kleur] .bp__swatch.is-active');
    var n = a ? String(a.dataset.value || '').toLowerCase() : '';
    return LICHT.some(function (w) { return n.indexOf(w) >= 0; });
  }
  function kleurByLabel(l) { for (var i = 0; i < kleurBtns.length; i++) if (kleurBtns[i].dataset.label === l) return kleurBtns[i]; return kleurBtns[0]; }
  function pickKleur(btn, manual) {
    state.kleur = btn; if (manual) state.kleurGekozen = true;
    setPressed(kleurBtns, btn, 'aria-checked');
    root.querySelector('[data-tt-btx-kleur-label]').textContent = btn.dataset.label;
  }
  function autoKleur() { if (!state.kleurGekozen) pickKleur(kleurByLabel(garmentLight() ? 'Zwart' : 'Wit'), false); }

  // Font loading: on demand, once per font. The promise rejects when the file cannot be loaded (no fallback letter in the PNG).
  function laadFont(btn) {
    var key = btn.dataset.family;
    if (!state.fonts[key]) {
      var ff = new FontFace(key, 'url(' + btn.dataset.url + ')', { weight: btn.dataset.weight });
      state.fonts[key] = ff.load().then(function (f) { document.fonts.add(f); return f; });
      state.fonts[key].catch(function () { delete state.fonts[key]; });
    }
    return state.fonts[key];
  }
  function preload() { fontBtns.forEach(function (b) { laadFont(b).catch(function () {}); }); }

  function teken(text, fontBtn, hex) {
    var c = document.createElement('canvas'), ctx = c.getContext('2d');
    var spec = function (px) { return fontBtn.dataset.weight + ' ' + px + 'px "' + fontBtn.dataset.family + '"'; };
    var px = 240, m, pad;
    ctx.font = spec(px); m = ctx.measureText(text);
    var w0 = m.actualBoundingBoxLeft + m.actualBoundingBoxRight;
    // keep the PNG between 700 and 2400 px wide
    px = Math.max(40, Math.min(480, Math.round(px * Math.max(700, Math.min(2400, w0)) / Math.max(1, w0))));
    ctx.font = spec(px); m = ctx.measureText(text);
    pad = Math.round(px * 0.15);
    c.width = Math.ceil(m.actualBoundingBoxLeft + m.actualBoundingBoxRight) + pad * 2;
    c.height = Math.ceil(m.actualBoundingBoxAscent + m.actualBoundingBoxDescent) + pad * 2;
    ctx = c.getContext('2d');
    ctx.font = spec(px); ctx.fillStyle = hex; ctx.textBaseline = 'alphabetic';
    ctx.fillText(text, pad + m.actualBoundingBoxLeft, pad + m.actualBoundingBoxAscent);
    return c;
  }

  function stijlKiezen() {
    var b = bp.querySelector('[data-bp-stijl] .bp__style[data-value^="Lijntekening"]');
    if (b && !b.classList.contains('is-active')) b.click();
  }

  function render() {
    var seq = ++state.seq, text = inp.value.replace(/\s+/g, ' ').trim();
    teller.textContent = inp.value.length + ' / ' + MAX;
    teller.classList.toggle('is-max', inp.value.length >= MAX);
    melden(inp.value.length >= MAX ? root.dataset.msgMax : '');
    if (!text) { if (ours()) clearDesign(); props(false); return; }
    if (!ALLOWED.test(text)) { if (ours()) clearDesign(); props(false); melden(root.dataset.msgTekens); return; }
    var fontBtn = state.font, kleurBtn = state.kleur;
    melden(root.dataset.msgLaden && !state.fonts[fontBtn.dataset.family] ? root.dataset.msgLaden : melding.textContent);
    laadFont(fontBtn).then(function () {
      if (seq !== state.seq) return; // a newer keystroke owns the preview
      var cv = teken(text, fontBtn, 'rgb(' + kleurBtn.dataset.rgb.split(' ').join(',') + ')');
      cv.toBlob(function (blob) {
        if (seq !== state.seq || !blob) return;
        var file = new File([blob], FILE_NAME, { type: 'image/png' });
        var dt = new DataTransfer(); dt.items.add(file); fileIn.files = dt.files;
        out.tekst.value = text; out.font.value = fontBtn.dataset.label; out.kleur.value = kleurBtn.dataset.label;
        props(true); out.tekst.value = text; out.font.value = fontBtn.dataset.label; out.kleur.value = kleurBtn.dataset.label;
        melden(inp.value.length >= MAX ? root.dataset.msgMax : '');
        stijlKiezen();
        fileIn.dispatchEvent(new Event('change', { bubbles: true }));
      }, 'image/png');
    }, function () {
      if (seq !== state.seq) return;
      if (ours()) clearDesign();
      props(false); melden(root.dataset.msgFont);
    });
  }

  function setModus(m) {
    if (m === state.modus) return;
    state.modus = m;
    knoppen.forEach(function (b) { var on = b.dataset.ttBtxModus === m; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    var tekst = m === 'tekst';
    paneel.hidden = !tekst;
    if (uploadPaneel) uploadPaneel.hidden = tekst;
    state.seq++; // drop a render that is still waiting for a font
    // the other input is wiped: an uploaded file when typing, the typed text (and its PNG) when uploading
    if (fileIn.files && fileIn.files.length) clearDesign();
    props(false); melden('');
    if (tekst) { autoKleur(); preload(); inp.focus(); render(); }
    else { inp.value = ''; teller.textContent = '0 / ' + MAX; teller.classList.remove('is-max'); }
    var e = bp.querySelector('[data-bp-err-file]'); if (e) e.hidden = true;
  }

  knoppen.forEach(function (b) { b.addEventListener('click', function () { setModus(b.dataset.ttBtxModus); }); });
  var timer = null;
  inp.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(render, 120); teller.textContent = inp.value.length + ' / ' + MAX; teller.classList.toggle('is-max', inp.value.length >= MAX); });
  fontBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      state.font = b; setPressed(fontBtns, b, 'aria-checked');
      root.querySelector('[data-tt-btx-font-label]').textContent = b.dataset.label; render();
    });
  });
  kleurBtns.forEach(function (b) { b.addEventListener('click', function () { pickKleur(b, true); render(); }); });
  // a new garment colour changes the default thread colour until the customer picks one
  bp.querySelectorAll('[data-bp-kleur] .bp__swatch').forEach(function (b) {
    b.addEventListener('click', function () { if (state.modus === 'tekst' && !state.kleurGekozen) { autoKleur(); render(); } });
  });
  // a file chosen through the upload field while typing (should not happen, the field is hidden) wins over typed text
  fileIn.addEventListener('change', function () { if (state.modus === 'tekst' && !ours()) { inp.value = ''; props(false); } });

  root.querySelector('[data-tt-btx-font-label]').textContent = state.font.dataset.label;
  autoKleur();
  window.TTBorduurtekst = { modus: function () { return state.modus; } };
})();
